import React from 'react';

const NotFound = () => {
  return (
    <div style={{ minHeight: '100vh', padding: '80px 20px', textAlign: 'center' }}>
      <h1>NotFound Page</h1>
      <p>This page is under construction</p>
    </div>
  );
};

export default NotFound;
